/* ============================================================
   AQEELAB - UNIFIED TABS/ACCORDION
   ------------------------------------------------------------
   Strategie :
   - Mobile (< 750px) : on ne touche a rien, l'accordion natif marche
   - Desktop (>= 750px) :
     * On cree une nav de boutons en haut du conteneur
     * On clone le texte des summaries dans cette nav
     * Cliquer sur un bouton de nav ouvre le <details> correspondant
       et ferme les autres
     * Les <details> originaux gardent leur structure mais leur
       <summary> est cache via CSS
   ============================================================ */

(function () {
  'use strict';

  const DESKTOP_BREAKPOINT = 750;
  const CONTAINER_SELECTOR = '.aq-unified-tabs .accordions';

  function isDesktop() {
    return window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`).matches;
  }

  function initContainer(container) {
    // Eviter la double initialisation
    if (container.dataset.unifiedInit === '1') return;
    container.dataset.unifiedInit = '1';

    const detailsList = container.querySelectorAll('details.accordion');
    if (detailsList.length === 0) return;

    // Creer la nav et l'inserer en haut du conteneur
    const nav = document.createElement('div');
    nav.className = 'aq-tabs-nav';
    container.insertBefore(nav, container.firstChild);

    // Pour chaque details, creer un bouton dans la nav
    const buttons = [];
    detailsList.forEach((details, index) => {
      const summary = details.querySelector('summary.accordion__header');
      if (!summary) return;

      const titleEl = summary.querySelector('.accordion__heading-title');
      const titleText = titleEl ? titleEl.textContent.trim() : `Onglet ${index + 1}`;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'aq-tab-btn';
      button.textContent = titleText;
      button.dataset.tabIndex = String(index);

      button.addEventListener('click', function () {
        if (!isDesktop()) return;
        activateTab(index);
      });

      nav.appendChild(button);
      buttons.push(button);
    });

    // Etat : index actif courant
    let activeIndex = 0;

    function activateTab(index) {
      detailsList.forEach((d, i) => {
        d.open = (i === index);
      });
      buttons.forEach((b, i) => {
        b.classList.toggle('aq-tab-btn--active', i === index);
      });
      activeIndex = index;
    }

    // Initialisation : on cherche le premier details deja ouvert,
    // sinon on ouvre le premier
    let initialIndex = 0;
    detailsList.forEach((d, i) => {
      if (d.open && initialIndex === 0 && i > 0) {
        initialIndex = i;
      }
    });
    // Si aucun n'est ouvert, ouvrir le premier
    const anyOpen = Array.from(detailsList).some((d) => d.open);
    if (!anyOpen) {
      initialIndex = 0;
    } else {
      initialIndex = Array.from(detailsList).findIndex((d) => d.open);
      if (initialIndex < 0) initialIndex = 0;
    }

    // Appliquer l'etat initial seulement si desktop
    if (isDesktop()) {
      activateTab(initialIndex);
    } else {
      // En mobile, marquer l'actif visuel pour les boutons (au cas ou)
      buttons[initialIndex]?.classList.add('aq-tab-btn--active');
    }

    // Gerer le changement de viewport
    const mql = window.matchMedia(`(min-width: ${DESKTOP_BREAKPOINT}px)`);
    mql.addEventListener('change', function (e) {
      if (e.matches) {
        // Passage en desktop : s'assurer qu'un seul details est ouvert
        let firstOpen = -1;
        detailsList.forEach((d, i) => {
          if (d.open) {
            if (firstOpen < 0) firstOpen = i;
            else d.open = false;
          }
        });
        if (firstOpen < 0) firstOpen = 0;
        activateTab(firstOpen);
      } else {
        // Passage en mobile : on laisse les details tels quels
        // Le CSS desactive la nav automatiquement
      }
    });

    // Sur desktop, intercepter le clic natif sur les summaries cachees
    // (au cas ou un utilisateur les active via clavier/accessibilite)
    detailsList.forEach((d, i) => {
      const summary = d.querySelector('summary.accordion__header');
      if (!summary) return;
      summary.addEventListener('click', function (ev) {
        if (!isDesktop()) return;
        ev.preventDefault();
        activateTab(i);
      });
    });
  }

  function init() {
    const containers = document.querySelectorAll(CONTAINER_SELECTOR);
    containers.forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
